import { QUOTE } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import QuotePage from "./container/QuotePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.any],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: QUOTE,
    withSidebar: true,
    withAppBar: true,
    component: QuotePage,
  };
}
